import { render, staticRenderFns } from "./PreviewForm10CM.vue?vue&type=template&id=72b321da"
import script from "./PreviewForm10CM.vue?vue&type=script&lang=ts"
export * from "./PreviewForm10CM.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports